import qs from 'qs'
import { evolve, filter, isNil, not, pipe } from 'ramda'
import { isEmptyString } from 'ramda-adjunct'
import api from './APIInterceptor'

const parsePayload = evolve({
  filter: pipe(filter(pipe(isEmptyString, not)), filter(pipe(isNil, not)))
})

const toQueryString = filters => {
  const query = parsePayload(filters)
  const queryString = qs.stringify(query)

  return queryString ? `?${queryString}` : ''
}

export default class ExchangeRoomsService {
  static getRooms(exchangeType, filters = {}) {
    return api.get(`/me/${exchangeType}/rooms${toQueryString(filters)}`)
  }

  static getDefaultRoom(exchangeType) {
    return api.get(`/me/${exchangeType}/rooms/default`)
  }

  static createRoom(exchangeType, payload) {
    return api.post(`/me/${exchangeType}/rooms`, payload)
  }

  static updateRoom(exchangeType, roomId, payload) {
    return api.patch(`/me/${exchangeType}/rooms/${roomId}`, payload)
  }

  static deleteRoom(exchangeType, roomId) {
    return api.delete(`/me/${exchangeType}/rooms/${roomId}`)
  }

  static getRoomMembers(exchangeType, roomId, filters = {}) {
    return api.get(
      `/me/${exchangeType}/rooms/${roomId}/members${toQueryString(filters)}`
    )
  }

  static addRoomMember(exchangeType, roomId, companyId) {
    return api.post(`/me/${exchangeType}/rooms/${roomId}/members`, {
      companyId
    })
  }

  static removeRoomMember(exchangeType, roomId, memberId) {
    return api.delete(`/me/${exchangeType}/rooms/${roomId}/members/${memberId}`)
  }

  static searchCandidates(exchangeType, roomId, filters = {}) {
    return api.get(
      `/me/${exchangeType}/rooms/${roomId}/candidates${toQueryString(filters)}`
    )
  }
}
